export function checkToken(req) {
  const str = req?.headers.cookie || ''
  const token = ~str.indexOf('token=') ? str.slice(str.indexOf('token=') + 6, str.indexOf(';', str.indexOf('token=') + 6)) : null
  return token
}
